
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sitemap/[section]/[page]",
      function () {
        return require("private-next-pages/sitemap/[section]/[page].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sitemap/[section]/[page]"])
      });
    }
  